<template>
  <resource-list-layout :resourceTitle="title" :showFooter="false">
    <template v-slot:filter>
      <order-view-fitter :fitter="searchObj" @changeNowDate="changeNowDate" @convertChange="convertChange" :admin-users-lists="adminUsersLists" />
    </template>
    <resource-list-page-content class="order-view" :height="null" max-height="580" :pageData="rows" :cols="cols" v-loading="loading" :show-summary="true" :get-summaries="getSummaries" />
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import OrderViewFitter from "./common/OrderViewFitter.vue";
import OrderTotal from "./common/OrderTotal.vue";
export default {
  name: "OrderView",
  components: { ResourceListLayout, ResourceListPageContent, OrderViewFitter },
  props: {
  },
  watch: {
  },
  data() {
    return {
      title: '订单记录表',
      cols: [],
      rows: [],
      loading: false,
      searchObj: {
        month: '',
        convert: ''
      },
      adminUsersLists: [],
      componentKey: 0
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchObj) {
        str += "&" + key + "=" + this.searchObj[key]
      }
      return str
    }
  },
  methods: {
    formatDate () {
      let date = new Date()
      let year = date.getFullYear()
      let month = (1 + date.getMonth()).toString()
      month = month.padStart(2, '0')
      this.searchObj.month = year + '-' + month
    },
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/data_overview/order_view?page=1' + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.cols = data.data.cols.map(col => ({
              ...col,
                component: OrderTotal
            }))
            this.$nextTick(() => {
              this.rows = data.data.rows
            })
            // setTimeout(() => {
            //   this.rows = data.data.rows
            // }, 500)
            this.adminUsersLists = data.data.adminUsersLists
            this.loading = false
          }
        })
    },
    getSummaries ({ columns, data }) {
      const summaries = []
      summaries[0] = "总计" // 第一列显示 "总计"

      columns.slice(1).forEach((column, index) => {
        const field = column.property
        let totalOrderCount = 0
        let totalAmount = 0

        data.forEach((row) => {
          const value = row[field]
          if (value) {
            const match = value.match(/订单：(\d+).*金额：([\d.]+)/)
            if (match) {
              totalOrderCount += parseInt(match[1], 10)
              totalAmount += parseFloat(match[2])
            }
          }
        })

        summaries[index + 1] =
          totalOrderCount > 0
            ? `订单：${totalOrderCount} \n 金额：${totalAmount.toFixed(2)}`
            : ""
      })

      return summaries
    },
    changeNowDate (val) {
      if (val) this.fetchData()
    },
    convertChange (val) {
      this.fetchData()
    }
  },
  mounted() {
    this.formatDate()
    this.fetchData()
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.clearfix:before,
.clearfix:after
.text-r
  text-align: right
.text-c
  text-align: center
.layout-container
  marginLeft()
  .mb20
    margin-bottom: .4rem
.order-view >>> .cell {
  white-space: pre-line;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/OrderView.vue